import content_vue_vue_type_script_setup_true_lang_default from "./content.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/popper/src/content.vue
var content_default = content_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { content_default as default };
//# sourceMappingURL=content2.mjs.map